import { FlexTemplateNode, FlexTemplateNodeProps } from 'flex-template-renderer-react';
import * as React from 'react';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiAboutThisPropertyWrapper } from 'components/infosite/shared-ui/details/about-this-property-wrapper';

interface FlexTemplate extends FlexTemplateNode {
  options: {
    columns?: number;
  };
}

export interface AboutThisPropertyProps extends FlexTemplateNodeProps {
  flexTemplateNode: FlexTemplate;
}

export const AboutThisPropertyWrapper: React.FC<AboutThisPropertyProps> = ({ flexTemplateNode }) => (
  <UitkSpacing margin={{ medium: { blockstart: 'six' }, small: { blockstart: 'six' } }}>
    <div>
      <SharedUiAboutThisPropertyWrapper columns={flexTemplateNode.options.columns} />
    </div>
  </UitkSpacing>
);
